import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "removeproductsfromwishlist-mutation"
    }}>{`removeProductsFromWishlist mutation`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`removeProductsFromWishlist`}</inlineCode>{` mutation completely removes the specified items from the customer's wish list. Use the `}<a parentName="p" {...{
        "href": "remove-products.md"
      }}><inlineCode parentName="a">{`updateProductsInWishlist`}</inlineCode>{` mutation`}</a>{` to change the quantity of specific items in the wish list.`}</p>
    <p>{`This mutation requires a valid `}<a parentName="p" {...{
        "href": "../../customer/mutations/generate-token.md"
      }}>{`customer authentication token`}</a>{`.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  removeProductsFromWishlist(
    wishlistId: ID!
    wishlistItemsIds: [ID!]!
  ) {
    RemoveProductsFromWishlistOutput
  }
}
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-removeProductsFromWishlist"
      }}><inlineCode parentName="a">{`removeProductsFromWishlist`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example removes an item that was added in the `}<a parentName="p" {...{
        "href": "add-products.md"
      }}><inlineCode parentName="a">{`addProductsToWishlist`}</inlineCode>{` mutation`}</a>{` example.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  removeProductsFromWishlist(
  wishlistId: 4
  wishlistItemsIds: [
    26
  ]){
    wishlist {
      id
      items_count
      items_v2 {
        items {
          id
          quantity
          product {
            uid
            name
            sku
            price_range {
              minimum_price {
                regular_price  {
                  currency
                  value
                }
              }
              maximum_price {
                regular_price {
                  currency
                  value
                }
              }
            }
          }
        }
      }
    }
    user_errors {
      code
      message
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "removeProductsFromWishlist": {
      "wishlist": {
        "id": "4",
        "items_count": 2,
        "items_v2": {
          "items": [
            {
              "id": "27",
              "quantity": 1,
              "product": {
                "uid": "MTIyNg==",
                "name": "Stellar Solar Jacket",
                "sku": "WJ01",
                "price_range": {
                  "minimum_price": {
                    "regular_price": {
                      "currency": "USD",
                      "value": 75
                    }
                  },
                  "maximum_price": {
                    "regular_price": {
                      "currency": "USD",
                      "value": 75
                    }
                  }
                }
              }
            },
            {
              "id": "28",
              "quantity": 1,
              "product": {
                "uid": "NTI=",
                "name": "Sprite Yoga Companion Kit",
                "sku": "24-WG080",
                "price_range": {
                  "minimum_price": {
                    "regular_price": {
                      "currency": "USD",
                      "value": 61
                    }
                  },
                  "maximum_price": {
                    "regular_price": {
                      "currency": "USD",
                      "value": 77
                    }
                  }
                }
              }
            }
          ]
        }
      },
      "user_errors": []
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "errors"
    }}>{`Errors`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`The current user cannot perform operations on wishlist`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An unauthorized user (guest) tried to add an item to a wishlist, or an authorized user (customer) tried to add an item to a wishlist of another customer.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`The wishlist was not found.`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value provided in the `}<inlineCode parentName="td">{`wishlistId`}</inlineCode>{` field is invalid or does not exist for the customer.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      